import React, { ReactElement } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styles from './optional-signature-frame.module.css';

const messages = defineMessages({
  digitallySignedBy: {
    id: '',
    description: 'Label for the optional signature frame',
    defaultMessage: 'Digitally signed by:',
  },
});

export const OptionalSignatureFrame = ({
  children,
  isEnabled,
  scale,
}: {
  children: ReactElement;
  isEnabled: boolean;
  scale: number;
}) => {
  const intl = useIntl();
  return isEnabled ? (
    <>
      <div className={styles.frame} style={{ '--scale': scale }}>
        <div className={styles.frameTopLeftCorner}></div>
        <div className={styles.frameLabel}>
          {intl.formatMessage(messages.digitallySignedBy)}
        </div>
        <div className={styles.frameLeftEdgeAndBottomLeftCorner}></div>
      </div>
      {children}
    </>
  ) : (
    children
  );
};
